import React from "react";
import { Box } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import { Swiper, SwiperSlide } from "swiper/react";
import airFilter from "../../Images/airFilter.jpg";
import fuelFilter from "../../Images/fuelFilter.jpg";
import oilFilter from "../../Images/oilFilter.jpg";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css";

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { routes } from "../../constants/routes";
import UniqueQuality from "./UniqueQuality";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    // backgroundColor: "#E5E8E8",

    marginTop: "40px",
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  root: {
    // maxWidth: 345,
    marginTop: "50px",
    marginBottom: "70px",
    borderRadius: "12px",
    marginLeft: "4.5%",
    width: "27%",
    "&:hover": {
      "& $filterTitle": {
        backgroundColor: "#36404b",
      },
    },
  },
  mobileRoot: {
    marginTop: "25px",
    marginBottom: "25px",
    borderRadius: "12px",
    marginLeft: "10.5%",
    // marginRight:'5.5%',
    width: "80%",
  },
  swiper: {
    marginTop: "20px",
    //  marginBottom:'50px',
    backgroundColor: "#E5E8E8",
    display: "block",
    zIndex: 0,
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  title: {
    marginTop: "20px",
    fontSize: 12,
    fontWeight: "bold",
    color: "#fff",
    textAlign: "center",
    backgroundColor: "#36404b",
    padding: "20px",
    borderBottomRightRadius: "100px",
    borderTopLeftRadius: "100px",
    [theme.breakpoints.up("sm")]: {
      fontSize: 24,
      marginTop: "40px",
    },
  },
  media: {
    height: 200,
  },
  filterTitle: {
    fontWeight:'bolder',
    backgroundColor: "#B20502",
    padding: "12px",
    color: "#fff",
    textAlign: "center",
    borderBottomRightRadius: "25px",
    borderTopLeftRadius: "25px",
  },
}));
const WhiteTextTypography = withStyles({
  root: {
    color: "#000",
    fontSize: "16px",
  },
})(Typography);
const Filters = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <>
      <Box className={classes.title}>
        BEST PERFORMANCE AND RELIABLE PRODUCTS
      </Box>

      <UniqueQuality />

      <Swiper
        className={classes.swiper}
        navigation
        id="swiper-color"
        // pagination={{clickable:true}}
        // scrollbar={{ draggable: true }}
        spaceBetween={50}
        slidesPerView={1}
        onSlideChange={() => console.log("slide change")}
      >
        <SwiperSlide>
          <Card className={classes.mobileRoot}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image={oilFilter}
                title="Contemplative Reptile"
              />
              <CardContent>
                <Typography
                  className={classes.filterTitle}
                  gutterBottom
                  variant="h5"
                  component="h2"
                >
                  Oil Filter
                </Typography>
                <WhiteTextTypography
                  variant="body2"
                  style={{ textAlign: "justify" }}
                >
                  GuardPlus Autocomp oil filters are engineered to the high
                  quality standards delivering the performance you want and the
                  engine protection you need. Under it we will show products
                  that will have their PDPs.
                </WhiteTextTypography>
              </CardContent>
            </CardActionArea>
          </Card>
        </SwiperSlide>
        <SwiperSlide>
          <Card className={classes.mobileRoot}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image={airFilter}
                title="Contemplative Reptile"
              />
              <CardContent>
                <Typography
                  className={classes.filterTitle}
                  gutterBottom
                  variant="h5"
                  component="h2"
                >
                  Air Filter
                </Typography>
                <WhiteTextTypography
                  variant="body2"
                  style={{ textAlign: "justify" }}
                >
                  GuardPlus Autocomp engine air filters are built to provide
                  optimal engine performance while removing harmful particles
                  and ensuring high airflow. Under it we will show products that
                  will have their PDPs
                </WhiteTextTypography>
              </CardContent>
            </CardActionArea>
          </Card>
        </SwiperSlide>
        <SwiperSlide>
          <Card className={classes.mobileRoot}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image={fuelFilter}
                title="Contemplative Reptile"
              />
              <CardContent>
                <Typography
                  className={classes.filterTitle}
                  gutterBottom
                  variant="h5"
                  component="h2"
                >
                  Fuel Filter
                </Typography>
                <WhiteTextTypography
                  variant="body2"
                  style={{ textAlign: "justify" }}
                >
                  GuardPlus fuel filters are made from high quality and durable
                  materials which help protect the fuel system and engine from
                  harmful particles. Under it we will show products that will
                  have their PDPs.
                </WhiteTextTypography>
              </CardContent>
            </CardActionArea>
          </Card>
        </SwiperSlide>
      </Swiper>
      <Box sx={{}} className={classes.container}>
        <Card className={classes.root}>
          <CardActionArea onClick={() => navigate(routes.OILFILTER)}>
            <CardMedia
              className={classes.media}
              image={oilFilter}
              title="Contemplative Reptile"
            />
            <CardContent>
              <Typography
                className={classes.filterTitle}
                gutterBottom
                variant="h5"
                component="h2"
              >
                Oil Filters
              </Typography>
              <WhiteTextTypography
                variant="body2"
                style={{ textAlign: "justify" }}
              >
                GuardPlus Autocomp oil filters are engineered to the high
                quality standards delivering the performance you want and the
                engine protection you need.
              </WhiteTextTypography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card className={classes.root}>
          <CardActionArea onClick={() => navigate(routes.AIRFILTER)}>
            <CardMedia
              className={classes.media}
              image={airFilter}
              title="Contemplative Reptile"
            />
            <CardContent>
              <Typography
                className={classes.filterTitle}
                gutterBottom
                variant="h5"
                component="h2"
              >
                Air Filters
              </Typography>
              <WhiteTextTypography
                variant="body2"
                style={{ textAlign: "justify" }}
              >
                GuardPlus Autocomp engine air filters are built to provide
                optimal engine performance while removing harmful particles and
                ensuring high airflow.
              </WhiteTextTypography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card className={classes.root}>
          <CardActionArea onClick={() => navigate(routes.FUELFILTER)}>
            <CardMedia
              className={classes.media}
              image={fuelFilter}
              title="Contemplative Reptile"
            />
            <CardContent>
              <Typography
                className={classes.filterTitle}
                gutterBottom
                variant="h5"
                component="h2"
              >
                Fuel Filters
              </Typography>
              <WhiteTextTypography
                variant="body2"
                style={{ textAlign: "justify" }}
              >
                GuardPlus fuel filters are made from high quality and durable
                materials which help protect the fuel system and engine from
                harmful particles.
              </WhiteTextTypography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Box>
    </>
  );
};
export default Filters;
